import {
  Component,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  input,
  output,
} from '@angular/core';
import { RouterModule } from '@angular/router';

import { LoaderComponent } from '../../../shared/components/loader/loader.component';

@Component({
  imports: [RouterModule, LoaderComponent],
  selector: 'semeris-search-result-header',
  templateUrl: './search-result-header.component.html',
  styleUrls: ['./search-result-header.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchResultHeaderComponent {
  public readonly title = input<string>(undefined);
  public readonly action = input<string>(undefined);
  public readonly actionLink = input<string[]>(undefined);
  public readonly actionQueryParams = input<Record<string, string>>(undefined);
  public readonly loading = input<boolean>(undefined);

  public readonly close = output();

  public onClose() {
    this.close.emit();
  }
}
